<!--
  a11y: audit reported that on mobile, after submitting a POI search the
  station results slide-up was not exposed as a dialog. SR/keyboard focus
  fell through to the underlying form's "search by address" field and an
  invisible map, never reaching the station cards visible on screen.
  Marking this slide-up as roleDialog gives it role=dialog + aria-modal=true
  and, combined with the new cdkTrapFocus in slide-up-card, keeps SR/Tab
  navigation confined to the results panel. The dialog is named by the
  slide-up's existing <h2> title ("Route planning"); the inner content
  header still shows the POI name as a visible secondary <h2> so SR users
  encounter it immediately while reading the dialog.
-->
<design-slide-up-card #card [isCardOpen]="!!isCardOpen" class="route-planning-results" [class]="direction"
  [showLogoInHeader]="true" [showBackgroundImage]="true" [title]="routePlanningText" [hideHeaderInDesktop]="true"
  [roleDialog]="true" [trapFocusOnOpen]="!!isMobile">
  <div class="flex flex-col h-full" [ngStyle]="isMobile ? { 'max-height': 'calc(100% - 4rem)' } : {}" id="printableArea" >
    <app-results-header
      [focusInitialOnBack]="!!isMobile"
      (onBackClick)="
        routePlanningService._mapOverlaySub.next(null); closeCard()
      ">
      <ng-container navigationButtons> </ng-container>

      <ng-container buttons>
        <mot-button type="button" icon="share-nodes" iconClass="text-2xl" buttonClass="!text-white !bg-transparent"
          [text]="shareText" (onClick)="openShareLinkPopup()" ariaHaspopup="dialog" />

          <mot-menu [menuVert]="false" [menuItems]="moreActionsMenuItems" [menuButtonAriaLabel]="moreActionsMenuText" dir="rtl"
            buttonClass="!rounded-xl !text-white !bg-transparent !w-8 !h-8 !min-w-0"
            buttonActiveClass="!rounded-xl !bg-white !w-8 !h-8 !min-w-0 !text-[#0C3058]"
            heightClass="!h-[4rem]" />
          </ng-container>

          <ng-container content>
            <div class="flex items-center gap-2">
              <ng-icon name="buildings" class="!text-xl text-primary-gold" aria-hidden="true" />
              <h2 class="text-base m-0 font-normal !text-white">{{ data.formValues.poi.name }}</h2>
            </div>
          </ng-container>
        </app-results-header>

        <div class="flex-1 max-h-full bg-white rounded-t-xl overflow-y-auto use-scrollbar">
          @if (!!isDesktop) {
            <app-search-stations-result-list class="block max-h-full" [stations]="data.stations" (closeStationListEvent)="closeCard()" (CloseWithReSubmitEvent)="closeCard(true)"/>
          } @else {
            <mat-tab-group [dir]="direction" mat-stretch-tabs="false" [disableRipple]="true" class="max-h-full flex-1 h-full use-padding">
              <mat-tab>
                <ng-template mat-tab-label>{{ stationsListText }}</ng-template>
                <app-search-stations-result-list [stations]="data.stations" (closeStationListEvent)="closeCard()" (CloseWithReSubmitEvent)="closeCard(true)"/>
              </mat-tab>
              @if (!!isMobile) {
                <mat-tab>
                  <ng-template mat-tab-label>{{ showOnMapText }}</ng-template>
                  <app-search-stations-result-map [data]="data" />
                </mat-tab>
              }
            </mat-tab-group>
          }
        </div>
      </div>
    </design-slide-up-card>


